import React from 'react';
import Plot from 'react-plotly.js';

export default function NuclearShareDropdown() {
  /* ----------  data  ---------- */
  const years = Array.from({ length: 33 }, (_, i) => 1990 + i); // 1990–2022

  const franceData = [0.7465, 0.7273, 0.7300, 0.7789, 0.7549, 0.7632, 0.7739, 0.7835,
    0.7589, 0.7498, 0.7689, 0.7662, 0.7812, 0.7781, 0.7808, 0.7838,
    0.7831, 0.7718, 0.7658, 0.7645, 0.7527, 0.7719, 0.7427, 0.7276,
    0.7623, 0.7549, 0.7148, 0.7089, 0.7099, 0.6991, 0.6648, 0.6834,
    0.6208];

  const swedenData = [0.4654, 0.5208, 0.4339, 0.4211, 0.5114, 0.4714, 0.5280, 0.4685,
    0.4633, 0.4726, 0.3946, 0.4462, 0.4642, 0.4978, 0.5107, 0.4568,
    0.4670, 0.4497, 0.4258, 0.3816, 0.3893, 0.4021, 0.3845, 0.4339,
    0.4222, 0.3476, 0.4045, 0.4000, 0.4195, 0.3926, 0.3003, 0.3083,
    0.3000];

  const koreaData = [0.4844, 0.4695, 0.4204, 0.3864, 0.3440, 0.3579, 0.3549, 0.3401,
    0.4098, 0.4273, 0.3769, 0.3616, 0.3641, 0.3747, 0.3529, 0.3790,
    0.3666, 0.3521, 0.3567, 0.3386, 0.3128, 0.2942, 0.2808, 0.2578,
    0.2899, 0.2996, 0.2886, 0.2603, 0.2265, 0.2567, 0.2790, 0.2593,
    0.2868];

  const japanData = [0.2323, 0.2376, 0.2471, 0.2734, 0.2778, 0.2941, 0.2989, 0.3085,
    0.3223, 0.3020, 0.3016, 0.3046, 0.2763, 0.2267, 0.2595, 0.2748,
    0.2727, 0.2311, 0.2329, 0.2565, 0.2462, 0.0916, 0.0145, 0.0084,
    0.0000, 0.0089, 0.0169, 0.0305, 0.0609, 0.0614, 0.0381, 0.0675,
    0.0550];

  const russiaData = [0.1093, 0.1123, 0.1186, 0.1246, 0.1117, 0.1157, 0.1287, 0.1301,
    0.1273, 0.1440, 0.1489, 0.1536, 0.1589, 0.1641, 0.1553, 0.1568,
    0.1571, 0.1576, 0.1568, 0.1649, 0.1642, 0.1639, 0.1658, 0.1629,
    0.1699, 0.1831, 0.1802, 0.1856, 0.1835, 0.1863, 0.1980, 0.1927,
    0.1940];

  /* ----------  traces  ---------- */
  const traces = [
    { x: years, y: franceData, name: 'France', visible: true, mode: 'lines+markers', type: 'scatter' },
    { x: years, y: swedenData, name: 'Sweden', visible: false, mode: 'lines+markers', type: 'scatter' },
    { x: years, y: koreaData, name: 'S. Korea', visible: false, mode: 'lines+markers', type: 'scatter' },
    { x: years, y: japanData, name: 'Japan', visible: false, mode: 'lines+markers', type: 'scatter' },
    { x: years, y: russiaData, name: 'Russia', visible: false, mode: 'lines+markers', type: 'scatter' }
  ];

  /* ----------  dropdown definition  ---------- */
  const dropdown = [{
    y: 1.17,
    x: 0.5,
    xanchor: 'center',
    yanchor: 'top',
    buttons: [
      {
        label: 'France',
        method: 'update',
        args: [
          { visible: [true, false, false, false, false] },
          { title: 'Nuclear Share – France' }
        ]
      },
      {
        label: 'Sweden',
        method: 'update',
        args: [
          { visible: [false, true, false, false, false] },
          { title: 'Nuclear Share – Sweden' }
        ]
      },
      {
        label: 'S. Korea',
        method: 'update',
        args: [
          { visible: [false, false, true, false, false] },
          { title: 'Nuclear Share – South Korea' }
        ]
      },
      {
        label: 'Japan',
        method: 'update',
        args: [
          { visible: [false, false, false, true, false] },
          { title: 'Nuclear Share – Japan' }
        ]
      },
      {
        label: 'Russia',
        method: 'update',
        args: [
          { visible: [false, false, false, false, true] },
          { title: 'Nuclear Share – Russia' }
        ]
      }
    ]
  }];

  return (
    <Plot
      data={traces}
      layout={{
        autosize: true,
        margin: { t: 50, b: 50, l: 50, r: 50 },
        title: 'Nuclear Share – France',
        updatemenus: dropdown,
        xaxis: { title: 'Year', fixedrange: true },
        yaxis: {
          title: 'Share of Electricity',
          tickformat: '.0%',
          range: [0.0, 1.0],
          fixedrange: true
        }
      }}
      useResizeHandler={true}
      style={{ width: '100%', height: '100%' }}
      config={{ displayModeBar: false, scrollZoom: false }}
    />
  );
}

